module.exports = __webpack_public_path__ + "resources/img/hompage_naver_map.b17a1cfc.png";